const i = {
  isSectionActive() {
    var e;
    return !!(this.sectionActive && (e = this.container) != null && e.isConnected);
  },
  scheduleSliderResize() {
    this.resizeFrame = requestAnimationFrame(() => {
      var e;
      (this.resizeFrame = null), this.isSectionActive() && ((e = this.slider) == null || e.resize());
    });
  },
  hideSection() {
    var e;
    (e = this.elements) != null &&
      e.section &&
      ((this.sectionHidden = !0), (this.elements.section.style.display = 'none'), this.elements.section.setAttribute('inert', ''));
  },
  showSection() {
    var e;
    (e = this.elements) != null &&
      e.section &&
      ((this.sectionHidden = !1), this.elements.section.style.removeProperty('display'), this.elements.section.removeAttribute('inert'));
  },
  destroySlider() {
    var e, t;
    cancelAnimationFrame(this.resizeFrame),
      (this.resizeFrame = null),
      (e = this.progressIndicator) == null || e.destroy(),
      (this.progressIndicator = null),
      (t = this.slider) == null || t.destroy(),
      (this.slider = null);
  },
  teardown() {
    var e;
    (this.sectionActive = !1),
      this.visibilityCleanup?.(),
      (this.visibilityCleanup = null),
      (this.sectionVisible = !1),
      this.sectionHidden && this.showSection(),
      (e = this.requestController) == null || e.abort(),
      (this.requestController = null),
      cancelAnimationFrame(this.initFrame),
      (this.initFrame = null),
      this.destroySlider();
  },
  onUnload() {
    this.teardown();
  },
};
export {i as s};
